import { Injectable } from '@angular/core';
import { BaseResolver } from '../../../shared/base-classes/base.resolver';
import { IBehaviorCodeListResolverData } from './behavior-codes-list-models/behavior-codes-list-resolver-data.interface';
import { AppResolverErrorHandlerService } from '../../../shared/services/resolver-error-handler.service';
import { AppBehaviorCodesService } from '../behavior-codes.service';
import {ActivatedRouteSnapshot} from "@angular/router";

@Injectable({ providedIn: 'root' })
export class AppBehaviorCodesListResolver extends BaseResolver<IBehaviorCodeListResolverData> {
  constructor(
    public resolverErrorHandler: AppResolverErrorHandlerService,
    public behaviorCodesService: AppBehaviorCodesService
  ) {
    super(resolverErrorHandler);
  }

  async handleResolve(
    route: ActivatedRouteSnapshot
  ): Promise<IBehaviorCodeListResolverData> {
    if (route.routeConfig.path.includes('district')) {
      return this.behaviorCodesService.getBehaviorDistrictCodesListPageResolverData() as unknown as IBehaviorCodeListResolverData
    } else {
      return this.behaviorCodesService.getBehaviorCodesListPageResolverData();
    }

  }
}
